// extracted by mini-css-extract-plugin
module.exports = {"Upcoming":"RecordingStatus-Upcoming-1YT323","New":"RecordingStatus-New-1oVZ0y","Live":"RecordingStatus-Live-bYtA0T","pulsate":"RecordingStatus-pulsate-1R7TKU"};